import React from 'react';
import { FiMenu } from 'react-icons/fi';

function TopNav({ title, children }) {

    return (
        <header className="flex items-center justify-between border-b border-primary/10 bg-white px-4 lg:px-10 py-3 sticky top-0 z-50 no-print">
            <div className="flex items-center gap-3 lg:gap-8">
                {/* Hamburger Menu (Mobile Only) */}
                <button
                    onClick={() => window.dispatchEvent(new CustomEvent('open-sidebar'))}
                    className="lg:hidden p-2 -ml-2 text-slate-800 hover:text-primary transition-colors"
                >
                    <FiMenu className="w-6 h-6" />
                </button>

                {/* Mobile logo */}
                <div className="flex lg:hidden items-center gap-2">
                    <img src="/logo.png" alt="GetYourQR" className="w-8 h-8 object-contain" />
                    <h2 className="text-lg font-bold leading-tight tracking-tight">GetYourQR</h2>
                </div>
                <h1 className="hidden lg:block text-lg font-bold tracking-tight">{title}</h1>

            </div>
            <div className="flex items-center gap-4">
                {children}
            </div>
        </header>
    );
}

export default TopNav;
